/**
 * Breadcrumbs dropdown logic
 */
function initBreadcrumbs() {
	class Breadcrumbs {
		/** @type {HTMLElement} */
		container;
		/** @type {HTMLElement} */
		popupElement;
		/** @type {HTMLButtonElement} */
		triggerButton;

		/**
		 * @param {HTMLElement} container
		 */
		constructor(container) {
			this.container = container;
			this.popupElement = container.querySelector('.breadcrumb-popup');
			this.triggerButton = container.querySelector('[data-action="breadcrumb-popup-trigger"]');

			if (this.triggerButton) {
				this.triggerButton.addEventListener('click', () => {
					this.togglePopup();
				});

				document.addEventListener('keydown', (e) => {
					if ((e.key === 'Escape' || e.keyCode === 27) && this.isPopupOpen()) {
						this.closePopup();
					}
				});

				if (this.popupElement) {
					clickedOutside(this.popupElement, () => {
						this.closePopup();
					}, [this.triggerButton]);
				}
			}
		}

		isPopupOpen() {
			return this.triggerButton
				&& this.triggerButton.getAttribute('aria-expanded') === 'true';
		}

		/**
		 * @param {boolean | null} force
		 */
		togglePopup(force = null) {
			const isOpen = this.isPopupOpen();
			const state = force !== null ? force : !isOpen;
			const stringifiedState = state ? 'true' : 'false';

			if (this.triggerButton) {
				this.triggerButton.setAttribute('aria-expanded', stringifiedState);
			}
		}

		openPopup() {
			this.togglePopup(true);
		}

		closePopup() {
			this.togglePopup(false);
		}
	}

	/** @type {NodeListOf<HTMLElement>} */
	const breadcrumbsContainers = document.querySelectorAll('nav.breadcrumbs');
	for (const breadcrumbContainer of breadcrumbsContainers) {
		new Breadcrumbs(breadcrumbContainer);
	}
}
